import { AbsoluteSmallButton } from "@src/appV2/redesign/components/AbsoluteSmallButton";
import { type IconButtonProps } from "@src/appV2/redesign/system/ui-components";

export function TopLeftBackButton(
  props: { onClick: () => void; includeTopSpacing?: boolean } & Partial<IconButtonProps>
) {
  return <AbsoluteSmallButton iconType="arrow-left" position="left" label="Back" {...props} />;
}
